import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class DownloadNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super('DOWNLOAD', _('menu.label.downloads'), AppRoute.Downloads, _('a11y.link.downloads'), 'LINKS');
  }
}
